<template>
  <header id="banner">
    <div class="banner-logo">
      <div class="container app">
        <div class="row">
          <div class="col-md-6 col-xl-4 order-md-2">
            <a href="https://www.nlr.gov">
              <div class="text-center text-md-end">
                <img src="@/assets/images/nlr-logo-horizontal.svg"  alt="" class="logo-img"/>
                <span class="sr-only">National Laboratory of the Rockies</span>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-xl-8 order-md-1">
            <a href="/" class="app-name">FleetREDI</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

